import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type { AssignmentFormItem } from "./AssignmentForm"
import type { Assignment } from "../../../graphql/types"

export const FETCH_ASSIGNMENTS_SUCCESS = "fetchAssignments/success"
export const fetchAssignmentsSuccess = (assignments: Assignment[]) => ({
    type: FETCH_ASSIGNMENTS_SUCCESS,
    payload: {
        assignments: assignments,
    },
})

export const FETCH_ASSIGNMENTS_FAILURE = "fetchAssignments/failure"
export const fetchAssignmentsFailure = (error: any) => ({
    type: FETCH_ASSIGNMENTS_FAILURE,
    payload: {
        error: error,
    },
})

export const ASSIGNMENT_FORM_SUBMITTED = "assignment/form/submitted"
export const assignmentFormSubmitted = (oldValue: Maybe<AssignmentFormItem>, newValue: AssignmentFormItem) => ({
    type: ASSIGNMENT_FORM_SUBMITTED,
    payload: {
        oldValue: oldValue,
        newValue: newValue,
    },
})

export const DELETE_ASSIGNMENT_CLICKED = "assignment/delete/clicked"
export const deleteAssignmentClicked = (id: string) => ({
    type: DELETE_ASSIGNMENT_CLICKED,
    payload: {
        assignmentId: id,
    },
})

export const CLOSE_ASSIGNMENT_FORM_CLICKED = "assignment/close/clicked"
export const closeAssignmentFormClicked = () => ({
    type: CLOSE_ASSIGNMENT_FORM_CLICKED,
})

export const ASSIGNMENTS_REORDERED = "ASSIGNMENTS_REORDERED"
export const assignmentsReordered = (newData: Assignment[]) => {
    return {
        type: ASSIGNMENTS_REORDERED,
        payload: {
            newData: newData,
        },
    }
}

export const ASSIGNMENTS_AGENDA_MOUNTED = "assignment/agenda/mounted"
export const assignmentsAgendaMounted = () => {
    return {
        type: ASSIGNMENTS_AGENDA_MOUNTED,
    }
}
